export enum IntegrateKoinlyStep {
  SsoType = 'SsoType',
  ApiKey = 'ApiKey',
  Authentication = 'Authentication',
  Sso = 'Sso',
}
